import gql from 'graphql-tag'

export const UserRoleFragment = gql`
	fragment UserRoleFragment on _UserToCompanyRole {
		A
		user {
			id
			profileCollection {edges{node{
				id
				firstName
				lastName
				avatarPath
			}}}
		}
		B
	}
`
